import { useMemo } from "react";

/** White-label brand of this page, injected by the server into index.html. */
export interface Brand {
  slug: string | null;
  name: string;
  productName: string;
  logoUrl: string | null;
  logoAlt: string;
  footerText: string | null;
}

export const DEFAULT_BRAND: Brand = {
  slug: null,
  name: "Suivi SIREN",
  productName: "Suivi SIREN",
  logoUrl: null,
  logoAlt: "",
  footerText: null,
};

export function readBrand(doc: Document = document): Brand {
  const content = doc.querySelector<HTMLMetaElement>('meta[name="suivi-brand"]')?.content;
  if (!content) return DEFAULT_BRAND;
  try {
    return { ...DEFAULT_BRAND, ...(JSON.parse(content) as Partial<Brand>) };
  } catch {
    return DEFAULT_BRAND;
  }
}

/** The brand never changes during a page's life: read the meta tag once per component. */
export function useBrand(): Brand {
  return useMemo(() => readBrand(), []);
}
